export const sanitizeDecimalSeparator = (decimal: string): string => decimal.replace(',', '.');
